import React from 'react'
import styled from '@emotion/styled'
import Button from 'src/components/Button'
import TextLink from 'src/components/TextLink'
import ConditionalRender from 'src/components/ConditionalRender'
import ScrollEntrance from 'src/components/ScrollEntrance'
import ContentfulRichText from 'src/components/ContentfulRichText'
import { typography, mq } from 'src/styles'

const Wrapper = styled.div`
	display: inline-block;
	display: block;
	vertical-align: top;
	${ ({ alignment }) => alignment === 'center' && `
		margin-left: auto;
		margin-right: auto;
		> div {
			margin-left: auto;
			margin-right: auto;
		}
	` }
	${ mq.mediumAndBelow } {
		display: block;
	}
`
const TextContainer = styled(ScrollEntrance)`
	text-align: ${ ({ alignment }) => alignment };
	width: 100%;
	${ ({ alignment }) => alignment === 'center' && `
		margin-left: auto;
		margin-right: auto;
	` }
	${ ({ alignment }) => alignment === 'right' && `
		margin-left: auto;
	` }
`

const Eyebrow = styled.p`
	${ typography.eyebrow }
	margin: 0 0 0.5em;
`

const Text = styled.div`
	h1, h2, h3, h4, h5 {
		${ ({ headlineSize }) => typography[headlineSize] }
	}
	p {
		${ ({ textSize }) => typography[textSize] }
		margin-bottom: 0;
		${ ({ alignment }) => alignment === 'center' && `
			margin-left: auto;
			margin-right: auto;
		` }
		${ ({ alignment }) => alignment === 'right' && `
			margin-left: auto;
		` }
	}
	ul, ol {
		paddind-left: 17px;
		margin: .5em 0;
		li {
			p {
				margin: .5em 0;
			}
		}
	}
`

const Headline = styled.h3`
	${ ({ headlineSize }) => typography[headlineSize] }
`

const ButtonActions = styled.div`
	margin-top: 30px;
	text-align: ${ ({ alignment }) => alignment };
	a, button {
		margin-bottom: 20px;
		${ ({ buttons }) => buttons.length > 1 && `
			min-width: 220px;
			margin-left: 10px;
			margin-right: 10px;
		` }
	}
`

const StyledButton = styled(Button)`
	margin-bottom: 18px;
	min-width: 172px;
	svg {
		display: none;
	}
`

const TextLockup = ({
		theme,
		eyebrow,
		headline,
    headlineSize,
    headlineStyle,
		text,
		textSize,
		buttons,
		className,
		icon,
		alignment,
    headlineElement,
		additions,
		entranceDelay,
		transitionIn
	}) => {
	return (
		<Wrapper className={className} alignment={alignment}>
			<div>
				<TextContainer alignment={alignment} delay={entranceDelay} transitionIn={transitionIn}>
					<ConditionalRender condition={icon && icon.svgContent}>
						<div style={{ margin: 'auto', width: 50, height: 50, marginBottom: '1em' }} dangerouslySetInnerHTML={{ __html: icon && icon.svgContent }}/>
					</ConditionalRender>
					<ConditionalRender condition={eyebrow}>
						<div>
							<Eyebrow>{eyebrow}</Eyebrow>
						</div>
					</ConditionalRender>

					{headline &&
						<Headline className={(headlineStyle === 'serif' || headlineStyle === 'alternate' || headlineStyle === 'alternative') ? 'alt' : 'normal'} headlineSize={headlineSize} alignment={alignment}>{headline}</Headline>
					}

					{text && text.json &&
						<Text textSize={textSize} className={headlineStyle === 'serif' || headlineStyle === 'alternate' || headlineStyle === 'alternative' ? 'alt' : 'normal'} alignment={alignment}><ContentfulRichText richText={text.json}/></Text>
					}

					{typeof text === 'string' &&
						<Text textSize={textSize} className={headlineStyle === 'serif' || headlineStyle === 'alternate' ? 'alt' : 'normal'} alignment={alignment}><p>{text}</p></Text>
					}

					{text && typeof text !== 'string' && !text.json &&
						<Text textSize={textSize} className={headlineStyle === 'serif' || headlineStyle === 'alternate' ? 'alt' : 'normal'} alignment={alignment}>{text}</Text>
					}

					{additions && additions}

					{buttons && (
						<ButtonActions buttons={buttons} alignment={alignment}>
							{buttons.map((button, index) => {
								if (button.type === 'button') {
									return (
										<Button
											key={'button-' + index}
											to={button.to}
											theme={button.theme}
											external={button.external || false}
											target={button.target || ''}
											title={button.label}
										>
											{button.label}
										</Button>
									)
								} else {
									return (
										<TextLink
											key={'link-' + index}
											to={button.to}
											theme={button.theme}
											external={button.external || false}
											target={button.target || ''}
											title={button.label}
										>
											{button.label}
										</TextLink>
									)
								}
							})}
						</ButtonActions>
					)}
				</TextContainer>
			</div>
		</Wrapper>
	)
}

TextLockup.defaultProps = {
	alignment: 'inherit',
  textSize: 'body',
  headlineSize: 'h3',
  headlineStyle: 'normal',
	entranceDelay: 0,
	transitionIn: true
}

export default TextLockup
